import { render, staticRenderFns } from "./AoikumoReadOnlyBanner.vue?vue&type=template&id=99e473c6&"
import script from "./AoikumoReadOnlyBanner.vue?vue&type=script&lang=js&"
export * from "./AoikumoReadOnlyBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e473c6')) {
      api.createRecord('99e473c6', component.options)
    } else {
      api.reload('99e473c6', component.options)
    }
    module.hot.accept("./AoikumoReadOnlyBanner.vue?vue&type=template&id=99e473c6&", function () {
      api.rerender('99e473c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/AoikumoReadOnlyBanner.vue"
export default component.exports